<template>
    <Layout>
        <section class="">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Registration</h2>
                            <!-- <p>To make certain your registration is processed successfully, we ask that you please:</p> -->
                            <ul style="list-style-type:disc; margin-left: 2em">
                                <li>Please complete all <strong>mandatory fields</strong> for your registration to go through.</li>
                                <li><span>Once you submit your application, you will receive a confirmation email.</span> Please retain this email as it will be the only way to update your registration details, whenever needed.</li>
                            </ul>
                            <p>Should you have any questions, please email <a href="mailto:VirtualConference@EFGHERMES.com">VirtualConference@EFGHERMES.com</a></p>
                        </div>
                    </div>
                    <center>
                        <div class="col-md-4">
                            <div class="session_box alert alert-warning text-center center-block">
                                <span class="fa fa-warning fa-fw"></span>
                                Your Session will expire in <strong> <span id="timer">{{ remaining_timer }}</span>!</strong>
                            </div>
                        </div>
                    </center>
                </div>
            </div>
        </section>

        <section>
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-danger error-summary" v-if="errors.length > 0 || $v.registration_form.$invalid == true">
                                <ul>
                                    <li class="text-danger" v-if="form_options.enableLoginDetails ?  !$v.registration_form.login_details.username.required : false">Username field is required</li>
                                    <li v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.username.minLength : false" class="text-danger">Username must have at least 6 letters.</li>
                                    <li v-if="errors['username']" class="text-danger">{{ errors['username'] }}</li>
                                    <li v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.password.required : false"
                                    class="text-danger">Password field is required</li>
                                    <li v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.password.minLength : false"
                                    class="text-danger">Password must have at least 6 letters.</li>
                                    <li class="text-danger" v-if="form_options.enableLoginDetails == true? !$v.registration_form.login_details.password_confirmation.sameAs : false">Passwords must be identical.</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.job_title.required">Job title field is required</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.address.required">Address field is required</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.country_id.required">Country field is required</li>
                                    <!-- <li class="text-danger" v-if="form_options.isInvestor && !$v.registration_form.client_details.nationality_id.required">Nationality Field is required</li> -->
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.additional_email.email">Additional email is invalid email address</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.telephone.required">Telephone field is required</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.mobile.required">mobile field is required</li>
                                    <li class="text-danger" v-if="!$v.registration_form.client_details.assistant_email.email">Assistant email is invalid email address</li>
                                    <li class="text-danger" v-if="!$v.registration_form.available_slot.required">Available slot field is required</li>
                                    <li class="text-danger" v-if="form_options.isInvestor && !$v.registration_form.client_details.biography.required">Biography field is required</li>
                                    <li class="text-danger" v-if="!form_options.disable_arrival_dates ? !$v.registration_form.arrival_dates.arrival_date.minValue : false">Arrival date shouldn't be after the first attending day.</li>
                                    <li class="text-danger" v-if="!form_options.disable_arrival_dates ? !$v.registration_form.arrival_dates.arrival_date.required : false">Arrival
                                    Dates field is required</li>
                                    <li class="text-danger" v-if="!form_options.disable_arrival_dates ? !$v.registration_form.arrival_dates.arrival_time.required : false">Arrival time Field is required</li>
                                    <li class="text-danger" v-if="!form_options.disable_depature_dates ? !$v.registration_form.arrival_dates.departure_date.required : false">departure date field is required</li>
                                    <li class="text-danger" v-if="!form_options.disable_depature_dates ? !$v.registration_form.arrival_dates.departure_date.minValue : false">Depature date shouldn't be after the last attending day.</li>
                                    <li class="text-danger" v-if="!form_options.disable_depature_dates ? !$v.registration_form.arrival_dates.departure_time.required : false">Departure Time Field is required</li>
                                </ul>
                            </div>
                            <fieldset>
                                <legend>Login Details</legend>
                                <p>Please create a Username and Password that you can use to access your personal registration information in the future, and then click the &quot;Submit&quot; button.</p>
                                <table>

                                    <tr><td :class="{'has-error' : (form_options.enableLoginDetails ? ($v.registration_form.login_details.username.$invalid || errors['username']) : false)}">
                                        <label> Username <span class="required">*</span></label>
                                        <input :disabled="!form_options.enableLoginDetails" v-model="registration_form.login_details.username" type="text" />
                                        <small class="text-danger" v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.username.required : false">Field is required</small>
                                        <small v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.username.minLength : false"
                                                class="text-danger">Username must have at least 6 letters.</small>
                                        <small v-if="errors['username']"
                                                class="text-danger">{{ errors['username'] }}</small>

                                    </td></tr>
                                    <tr><td :class="{'has-error' : (form_options.enableLoginDetails ? $v.registration_form.login_details.password.$invalid : false)}">
                                        <label> Password <span class="required">*</span></label>
                                        <input  :disabled="!form_options.enableLoginDetails" v-model="registration_form.login_details.password" type="password" />
                                        <small v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.password.required : false"
                                                class="text-danger">Field is required</small>
                                        <small v-if="form_options.enableLoginDetails ? !$v.registration_form.login_details.password.minLength : false"
                                                class="text-danger">Password must have at least 6 letters.</small>
                                    </td></tr>
                                    <tr><td :class="{'has-error' : (form_options.enableLoginDetails ? $v.registration_form.login_details.password_confirmation.$invalid : false)}">
                                        <label> Confirm Password <span class="required">*</span></label>
                                        <input  :disabled="!form_options.enableLoginDetails" v-model="registration_form.login_details.password_confirmation" type="password" />
                                         <small class="text-danger" v-if="form_options.enableLoginDetails == true? !$v.registration_form.login_details.password_confirmation.sameAs : false">Passwords must be identical.</small>
                                    </td></tr>
                                     <tr>
                                        <td v-show="form_options.clientHasAppUser">
                                            <p><input v-model="form_options.enableLoginDetails" type="checkbox" />Update my login details ? </p>
                                        </td>
                                    </tr>
                                </table>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-sm">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <fieldset>
                                <legend>Personal Details</legend>
                                <table>
                                    <tr>
                                        <td>
                                            <label>Title</label>
                                            <input v-model="registration_form.client_details.title" disabled="" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>First Name</label>
                                            <input v-model="registration_form.client_details.first_name" disabled="" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Middle Name</label>
                                            <input disabled="" v-model="registration_form.client_details.middle_name"  type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Family Name</label>
                                            <input v-model="registration_form.client_details.family_name" disabled="" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.job_title.$invalid }">
                                            <label> Job Title <span class="required">*</span></label>
                                            <input v-model="registration_form.client_details.job_title" type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form.client_details.job_title.required">Field is required</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Company</label>
                                            <input v-model="registration_form.client_details.company" disabled="" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.address.$invalid }">
                                            <label>Address <span class="required">*</span></label>
                                            <textarea v-model="registration_form.client_details.address"></textarea>
                                            <small class="text-danger" v-if="!$v.registration_form.client_details.address.required">Field is required</small>
                                        </td>
                                    </tr>
                                    <tr v-if="form_options.isInvestor">
                                        <td>
                                            <label>Biography (Company/Personal Bio) <span class="required">*</span></label>
                                            <textarea v-model="registration_form.client_details.biography"></textarea>
                                            <small class="text-danger" v-if="!$v.registration_form.client_details.biography.required">Field is required</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.country_id.$invalid }">
                                            <label>Country <span class="required">*</span></label>
                                            <select v-model="registration_form.client_details.country_id">
                                                <!-- <option :value="null">[Please Select]</option> -->
                                                <option v-for="country in lists.countries" :value="country.id" :key="country.id">{{ country.name }}</option>
                                            </select>
                                             <small class="text-danger" v-if="!$v.registration_form.client_details.country_id.required">Field is required</small>
                                        </td>
                                    </tr>
                                    <!-- <tr v-if="form_options.isInvestor">
                                        <td :class="{'has-error' : $v.registration_form.client_details.nationality_id.$invalid }">
                                            <label>Nationality <span class="required">*</span></label>
                                            <select v-model="registration_form.client_details.nationality_id">
                                                <option :value="null">[Please Select]</option>
                                                <option v-for="country in lists.countries" :value="country.id">{{ country.name }}</option>
                                            </select>
                                             <small class="text-danger" v-if="!$v.registration_form.client_details.nationality_id.required">Field is required</small>
                                        </td>
                                    </tr> -->

                                    <tr>
                                        <td>
                                            <label>E-mail <span class="required">*</span></label>
                                            <input disabled="" v-model="registration_form.client_details.email" type="text" />
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.email_confirmation.$invalid }">
                                            <label>Confirm E-mail *</label>
                                            <input v-model="registration_form.client_details.email_confirmation" type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form.client_details.email_confirmation.sameAs">Emails didnt match</small>
                                        </td>
                                    </tr> -->
                                    <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.additional_email.$invalid }">
                                            <label>Other E-mail</label>
                                            <input v-model="registration_form.client_details.additional_email" type="text" />
                                             <small class="text-danger" v-if="!$v.registration_form.client_details.additional_email.email">Invalid email address</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.telephone.$invalid }">
                                            <label>Telephone <span class="required">*</span></label>
                                            <input v-model="registration_form.client_details.telephone" type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form.client_details.telephone.required">Field is required</small>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td>
                                            <label>Fax</label>
                                            <input v-model="registration_form.client_details.fax" type="text" />
                                        </td>
                                    </tr> -->
                                    <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.mobile.$invalid }">
                                            <label>Mobile <span class="required">*</span></label>
                                            <input v-model="registration_form.client_details.mobile" type="text" />
                                            <small class="text-danger" v-if="!$v.registration_form.client_details.mobile.required">Field is required</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Name of your Assistant (for contact purposes)</label>
                                            <input v-model="registration_form.client_details.assistant_name" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Assistant's Phone</label>
                                            <input v-model="registration_form.client_details.assistant_phone" type="text" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td :class="{'has-error' : $v.registration_form.client_details.assistant_email.$invalid }">
                                            <label>Assistant's E-mail</label>
                                            <input v-model="registration_form.client_details.assistant_email" type="text" />
                                             <small class="text-danger" v-if="!$v.registration_form.client_details.assistant_email.email">Invalid email address</small>
                                        </td>
                                    </tr>
                                </table>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-sm">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <fieldset>
                                <legend>Days of Attendance</legend>
                                <table  :class="{ 'has-error': $v.registration_form.available_slot.$invalid }">

                                    <tr>
                                        <td>
                                            <p v-if="form_options.isInvestor">
                                              <!-- The meetings will be scheduled over 6 days according to the available slots indicated below. Presenting companies are set to present either 1-2 March or 3-4 March or 8-9 March. To guarantee maximum meeting allocation, please make sure that you are available at least 1 day in each of the days mentioned above.   -->
                                                <b> Meetings will be scheduled over 4 days from 9:00 – 18:50 Saudi Arabia Standard Time [UTC+03].
                                                    Presenting companies are set to present either 14-15 June or 16-17 June.
                                                </b> To guarantee maximum meeting allocation, please make sure that you are available at least 1 day in each of the days mentioned above.
                                            </p>
                                            <p v-else>
                                                The meetings will be scheduled over 4 days, you are kindly requested to choose the two days that best suit your schedule, either 14-15 June or 16-17 June so we can schedule your meetings accordingly.
                                                Meetings are scheduled daily from 9:00 – 18:50 Saudi Arabia Standard Time [UTC+03].
                                            </p>
                                        </td>
                                    </tr>
                                    <tr v-if="form_options.isInvestor" class="dates_investor">
                                        <td>

                                            <!-- <tr>
                                                <td> -->
                                                    <label>
                                                        <b>Please select your time zone/city then select your preferred time slots</b> <span class="required">*</span></label>
                                                    <VueSelect
                                                        style="display: block; margin-bottom: 1rem; width: 50%"
                                                        placeholder="Select Time Zone"
                                                        :options="this.timeZones"
                                                        @input="changeTimeZone"
                                                        :value="this.registration_form.timezone"
                                                    ></VueSelect>
                                                <!-- </td>
                                            </tr> -->

                                            <div v-if="this.registration_form.timezone.code">
                                                <div v-for="(timeslots, date) in lists.agenda_slots" :key="date">
                                                    <label>
                                                        {{ initDateFormat(date) }}
                                                    </label>
                                                    <label>
                                                        <input @change="selectAllSlots" type="checkbox" :value="date"> All
                                                    </label>
                                                    <label v-for="timeslot in timeslots" :key="timeslot.id">
                                                        <input v-model="registration_form.available_slot" type="checkbox" :value="timeslot.id"> {{ timeslot.start_time }}
                                                    </label>
                                                    <hr>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td>
                                            <div style="display: flex;width:100%; justify-content:start;">
                                                <div style="display: flex; flex-direction: column;margin-bottom:30px; margin-right: 50px"
                                                v-for="group in groupedSlots" :key="group.groupNumber">
                                                <div @click="selectGroup(group)">
                                                    <input v-model='selected_group' type='radio'
                                                    style='margin-right:10px;margin-bottom:10px'

                                                    :value='group.groupNumber'>{{group.groupTitle}}
                                                    </div>
                                                    <div v-if='selected_group == group.groupNumber'>
                                                        <div style="margin-bottom:10px"
                                                        v-for="(val, date, index) in group.slots" :key="date">
                                                            <input v-model="registration_form.available_slot"  type="checkbox" :value="date"
                                                            :disabled="isSlotDisabled(index, date) || isInLateRegister(date)"
                                                            @change="selectPresenterSlot(date, $event)"> {{ val.formattedDate }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>If you require further assistance, please email us at <a href="mailto:VirtualConference@EFGHERMES.com">VirtualConference@EFGHERMES.com</a></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <small class="text-danger" v-if="!$v.registration_form.available_slot.required">Field is required</small>
                                        </td>
                                    </tr>


                                </table>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <!-- Arrival &amp; Departure Details is in Backup -->

        <!-- <section class="section section-sm" v-if="form_options.isPresenter">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <fieldset>
                                <legend>Media interviews</legend>
                                    <label style="display: block">
                                        <div class="row"></div>
                                        <input v-model="registration_form.prefer_interview" type="checkbox" value="1"> Do you want to make interview with media presenters ?
                                    </label>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <section class="section section-sm" v-if="conference.hotel_accommodation">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <fieldset>
                                <legend>Hotel &amp; Accommodation Details</legend>
                                <div v-html="conference.hotel_accommodation"></div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-sm" v-if="form_options.enableRemarks == 1">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <fieldset><legend>Remarks</legend>
                                <textarea v-model="registration_form.remarks" placeholder="Enter your remarks here"></textarea>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-sm">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <input  @click="registerClientSubmitted" :value="form_options.isPresenter ? 'Submit' : 'Next'" type="submit" class="btn btn-outline-clr btn-sm" />
                            <!-- <p v-if="$v.registration_form.$invalid"><strong>Form has some invalid data please check.</strong></p>
                            <div class="alert alert-danger" v-show="errors.length">
                               <ul class="list-group">
                                   <li class="" v-for="error in errors" :key="error.message">{{ error.message }}</li>
                               </ul>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>
<script>

// import Datepicker from 'vuejs-datepicker';
import Layout from '@/components/layouts/Layout.vue'
import { required, requiredIf ,sameAsPassword, sameAs, minLength, email, numeric, minValue } from 'vuelidate/lib/validators'
var Timer = require('easytimer')
import Api from '@/Api'
import { mapState } from 'vuex';
import VueSelect from 'vue-select';
var moment = require('moment');
var momentTZ = require('moment-timezone');
import _ from 'lodash';
export default {
    name: 'Register',
    components: {
        Layout,
        // Datepicker,
        VueSelect
    },
    data() {
        return {
            selected_group:0,
            registration_form: {
                login_details: {
                    username: '',
                    password: '',
                    password_confirmation: '',
                },
                client_details: {
                    first_name: '',
                    middle_name: '',
                    family_name: '',
                    title:'',
                    job_title: '',
                    company: '',
                    address: '',
                    country_id: '',
                    nationality_id: '',
                    email: '',
                    // email_confirmation: '',
                    additional_email: '',
                    telephone: '',
                    // fax: '',
                    mobile: '',
                    assistant_name: '',
                    assistant_phone: '',
                    assistant_email: '',
                },
                timezone: {label: '', code: ''},
                arrival_dates: {
                    arrival_date: '',
                    arrival_time: '',
                    departure_date: '',
                    departure_time: '',
                },
                available_slot:[],
                conference_dates: {},
                selected_group:0,
                remarks: '',
                prefer_interview:0
            },
            //form_options.datepicketSetup.disabledDates.to
            form_options: {
                enableRemarks: 1,
                disable_arrival_dates: false,
                disable_depature_dates: false,
                disable_login_details_area: true,
                isInvestor: false,
                isPresenter: false,
                enableLoginDetails:false,
                clientHasAppUser: true,
                datepicketSetup: {
                    disabledDates: {
                        to :null,
                        from :null
                    }
                }
            },
            lists: {
                countries: [],
                agenda_slots: [],
                closed_days:[],
                closed_conference_days:[],
            },
            conference: {},
            remaining_timer: '00:00',
            errors: {}
        };
    },
    validations() {
        return {
          registration_form: {
            login_details: this.loginDetailsRules,
            client_details: this.clientDetailsRules,
            available_slot: {
                required
            },
            arrival_dates: this.arrivalDepatureRules,
          }
        }
    },
    watch: {
        'form_options.disable_arrival_dates': function(newVal, oldVal){
            if (newVal == true) {
                this.registration_form.arrival_dates.arrival_date = null
                this.registration_form.arrival_dates.arrival_time = null
            }
        },
        'form_options.disable_depature_dates': function(newVal, oldVal){
            if (newVal == true) {
                this.registration_form.arrival_dates.departure_date = null
                this.registration_form.arrival_dates.departure_time = null
            }
        },

    },
    methods: {
        isSlotDisabled(index, date){
            if(!this.selected_group)
                return false;
            // _.keys(this.lists.agenda_slots);
            if(this.registration_form.available_slot.includes(date))
                return false;
            const dayNumber = this.registration_form.conference_dates[date];
            let slotGroup = Math.ceil((dayNumber) / this.conference.split_days);
            return slotGroup !== this.selected_group;
        },
        isInLateRegister(date){
            const lateRegisterAvailableSLots = localStorage.getItem('lateRegisterAvailableSLots')
            let lateRegisterList;
            if(lateRegisterAvailableSLots && lateRegisterAvailableSLots != 'undefined') {
                lateRegisterList = JSON.parse(lateRegisterAvailableSLots);
            }
            if(!lateRegisterList || _.isEmpty(lateRegisterList)) return false;
            return true ;
        },
        selectGroup(group){
            this.registration_form.available_slot = [];
            _.each(group.slots, (slots,date)=>{
                this.registration_form.available_slot.push(date);
            });
        },
        selectPresenterSlot(date, ev){
            if(ev == true || ev.target.checked){
                const dayNumber = this.registration_form.conference_dates[date];
                this.selected_group = Math.ceil(dayNumber / this.conference.split_days)
            }else{
                if(!(this.registration_form && this.registration_form && this.registration_form.available_slot && this.registration_form.available_slot.length))
                    this.selected_group = 0;
            }

        },
        validate() {
            this.$v.$touch();
            this.$nextTick(() => {
                 this.scrollToFirstError();
            });
        },
        registerClientSubmitted(e) {
            e.preventDefault();
            this.errors = {};
            if (this.$v.registration_form.$invalid == true) {
                this.validate();
                return ;
            }

            let data = this.setupRegistrationDataRequest();
            data = _.omit(data , ['first_name' , 'middle_name' ,'family_name', 'company' , 'company_id' , 'country_id' , 'email' , 'nationality_id' , 'title']);
            Api().post('auth/signup', data)
                .then(response => {

                    let data = response.data;
                    let conference_end_date = new Date(this.conference.end_date).getTime() ;
                    let current_date = Date.now();
                    let client_type = localStorage.getItem("client") ?JSON.parse(localStorage.getItem("client")).client.client_type.type : null ;
                    if(!client_type) {
                        client_type = localStorage.getItem("registeration.client") ?JSON.parse(localStorage.getItem("registeration.client")).client.client_type.type : null
                    }
                    let firstRegisterTime = localStorage.getItem("firstTimeRegister") ? parseInt(localStorage.getItem("firstTimeRegister")) : 0 ;

                    if(client_type == 1) {
                        if(firstRegisterTime) {
                            Api().get(`me`, {params: {username: this.registration_form.login_details.username}}).then((res) => {
                                let user = res.data.user;
                                this.$store.dispatch("login", {user: user}).then(() => {
                                    // this.$router.push({name: 'Thank' })
                                    window.location.href = '/auth/preferences'; // this.$router.push({ name: 'preferences' });
                                })
                            })
                        }
                        // this.$router.push({name: 'Thank' })
                        this.$router.push({name: 'preferences' });
                    } else {
                        if( firstRegisterTime ) {
                            this.$store.dispatch("endRegisrationProccess")
                                .then(() => this.$router.push({name: 'Thank' }));
                        }
                        else {
                            this.$store.dispatch("endRegisrationProccess")
                                .then( ()=> this.$router.push({name:'ThankAfterRegistration'}));
                        }
                    }



                }).catch((error) => {
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;
                            this.errors = this.errorMapper(err.errors);
                            setTimeout(() => this.validate(), 1000);
                        }
                    }
                });
        },
        errorMapper(errors) {
            var errors_array = [];
            errors.forEach($element => {
                errors_array[$element.name] = $element.message;
            });
            return errors_array;

        },
        scrollToFirstError() {
            let domRect = document.querySelector('.error-summary,.has-error').getBoundingClientRect();
            window.scrollTo(
                domRect.left + document.documentElement.scrollLeft,
                domRect.top + document.documentElement.scrollTop - 255

            );
            /*let domRect = document.querySelector('.has-error').getBoundingClientRect();
            window.scrollTo(
                domRect.left + document.documentElement.scrollLeft,
                domRect.top + document.documentElement.scrollTop - 255

            );
            */
        },
        setupRegistrationDataRequest() {
            let login_details = this.registration_form.login_details;
            let client_details = this.registration_form.client_details;
            let arrival_dates = this.registration_form.arrival_dates;
            if (this.form_options.enableLoginDetails == false) {
                delete login_details['username']
                delete login_details['password']
                delete login_details['password_confirmation']
            }
            return {
                ...login_details,
                ...client_details,
                ...arrival_dates,
                timezone: this.registration_form.timezone.code,
                available_slot:this.registration_form.available_slot,
                remarks:this.registration_form.remarks,
                prefer_interview:this.registration_form.prefer_interview,
                invitation_code: this.registration_form.invitation_code,
            };
        },
        initClientDataIntoForm() {
            const client_all_data = JSON.parse(localStorage.getItem('registeration.client'));
            let client = client_all_data.client;
            let user = client.user;

            this.registration_form.client_details = {
                first_name: client.first_name,
                middle_name: client.middle_name,
                family_name: client.family_name,
                title: client.title.name,
                job_title: client.job_title,
                company: client.company.name,
                address: client.address,
                country_id: client.country_id,
                nationality_id: client.nationality_id,
                email: client.email,
                // email_confirmation: client.email_confirmation,
                additional_email: client.additional_email,
                telephone: client.telephone,
                // fax: client.fax,
                mobile: client.mobile,
                assistant_name: client.assistant_name,
                assistant_phone: client.assistant_phone,
                assistant_email: client.assistant_email,
                company_id: client.company_id,
                client_type_id: client.client_type_id,
                biography: client.biography
            };
            this.registration_form.timezone = client_all_data.timezone ?  {label: client_all_data.timezone + " (GMT"+momentTZ.tz(client_all_data.timezone).format('Z')+")", code: client_all_data.timezone} : {label: '',code: ''};
            this.registration_form.arrival_dates = {
                arrival_date: client_all_data.arrival_date,
                arrival_time: client_all_data.arrival_time,
                departure_date: client_all_data.departure_date,
                departure_time: client_all_data.departure_time,
            };
            this.registration_form.login_details.username = client.user ? client.user.username : '';
            this.registration_form.remarks = client_all_data.remarks;
            this.registration_form.available_slot = Array.isArray(client_all_data.available_slot) ? client_all_data.available_slot : [];
            this.registration_form.invitation_code = client_all_data.invitation_code;
            this.registration_form.prefer_interview = client_all_data.prefer_interview;

            this.form_options.isInvestor = client.client_type.type == 1;
            this.form_options.isPresenter = client.client_type.type == 2;
            this.form_options.clientHasAppUser = !!client.user
            if (!this.form_options.clientHasAppUser) {
                this.form_options.enableLoginDetails = true;
            }
            this.form_options.disable_arrival_dates = client_all_data.arrival_date == '' || client_all_data.arrival_date == null;
            this.form_options.disable_depature_dates = client_all_data.departure_date == '' || client_all_data.departure_date == null;
        },
        initForm() {
            let lists = JSON.parse(localStorage.getItem('registeration.lists'));
            this.lists.countries =  _.orderBy(lists.countries_list, [c => c.name.toLowerCase()]);
            this.lists.agenda_slots = lists.agenda_slots;
            this.lists.closed_days = lists.closed_days;
            this.lists.closed_conference_days = lists.closed_conference_days;
            this.form_options.datepicketSetup.disabledDates.to = new Date(new Date(this.conference.start_date) - (7*24*60*60*1000))
            this.form_options.datepicketSetup.disabledDates.from = new Date(new Date(this.conference.end_date).getTime() + (7*24*60*60*1000) + 86400000)
            this.form_options.enableRemarks = this.conference.web_enable_remark_box
        },
        selectAllSlots(e) {
            let el = e.target;
            let date = el.value;
            let timeslots = this.lists.agenda_slots[date];
            for (let i in timeslots) {
                let slot = timeslots[i];
                if (el.checked == true) {
                    // registration_form.available_slot
                    if (!this.registration_form.available_slot.includes(slot.id.toString())) {
                        this.registration_form.available_slot.push(slot.id.toString());
                    }
                }else {
                    let indexToDelete = this.registration_form.available_slot.indexOf(slot.id.toString());
                    this.registration_form.available_slot.splice(indexToDelete, 1);
                }
            }
        },
        initTimer(){
            var scope = this;
            let timerInSeconds = localStorage.getItem('registeration.timer') ? localStorage.getItem('registeration.timer') : 1;
            timerInSeconds = parseInt(timerInSeconds);
            if (timerInSeconds == 0) {
                this.$store.dispatch("endRegisrationProccess")
                    .then(() => scope.$router.push({name: 'identify'}));
            }
            var timer = new Timer();
            timer.start({countdown: true, startValues: {seconds: timerInSeconds }});

            scope.remaining_timer = timer.getTimeValues().toString();

            timer.addEventListener('secondsUpdated', function (e) {
                scope.remaining_timer = timer.getTimeValues().toString();
                localStorage.setItem('registeration.timer', timer.getTotalTimeValues().seconds)
            });
            timer.addEventListener('targetAchieved', function (e) {
                alert('Your session expired .... Please identify your self');
                scope.$store.dispatch("endRegisrationProccess")
                    .then(() => {
                        setTimeout(() => {
                            let client_storage = localStorage.getItem('client');
                            if (!_.isEmpty(client_storage)) {
                                scope.$router.push({name: 'identify'})
                            }
                            else {
                                scope.$router.push({name: 'login'})
                            }
                        })
                    }, 2000);
            });
        },
        fetchDataForUpdate() {
             Api().get(`auth/get-required-data-update-profile`)
                .then(response => {
                    let data = response.data;
                    this.$store.dispatch("startRegistrationProccess", data)
                    .then(() => {
                        window.location.reload();
                        // this.$router.push({name:"register"})
                    });
                })
                .catch((error) => {
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;
                            alert(err.errors[0].message);
                            this.$store.dispatch("endRegisrationProccess");
                            window.location.replace('/auth/login');
                        }

                    }
                });
        },
        startInit() {
            let conference = JSON.parse(localStorage.getItem('conference'));
            this.conference  = conference;
            this.initForm();
            this.initTimer();
            this.initClientDataIntoForm();

        },
        initDateFormat(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        timeUpdateHandler(event, input_name) {
            let timepicker = event.data;
            var time = `${timepicker.HH}:${timepicker.mm}`;
            if (input_name == 'arrival_time') {
                this.registration_form.arrival_dates.arrival_time = time;
            }
            else if(input_name == 'departure_time') {
                this.registration_form.arrival_dates.departure_time = time;
            }
        },
        getTimer(input_name) {
            var hour, min = null;
            if (input_name == 'arrival_time') {
                let time = this.registration_form.arrival_dates.arrival_time;
                if (time != null && time != '') {
                    let time_arr = time.split(':');
                    hour = time_arr[0];
                    min = time_arr[1];
                }
            }
            else if(input_name == 'departure_time') {
                let time = this.registration_form.arrival_dates.departure_time;
                if (time != null && time != '') {
                    let time_arr = time.split(':');
                    hour = time_arr[0];
                    min = time_arr[1];
                }
            }
            return {
                HH: hour,
                mm: min,
            };
        },
        validateArrivalDate (value) {
            for(let slot in this.registration_form.available_slot) {
                if(moment(value).isAfter(this.registration_form.available_slot[slot], 'date')) {
                    return false;
                }
            }
            return true;
        },
        validateDepatureRule (value) {
            for(let slot in this.registration_form.available_slot) {
                if(moment(value).isBefore(this.registration_form.available_slot[slot], 'date')) {
                    return false;
                }
            }
            return true;
        },
        changeTimeZone({ code, label }) {
            Object.keys(this.lists.agenda_slots).forEach(date => {
                this.lists.agenda_slots[date] = this.lists.agenda_slots[date].map(slot => {
                    const startTime = slot.start_time.replace(/\(.+\)/, '');
                    slot.start_time = this.convertTimeZone(`${slot.date} ${startTime}`, this.registration_form.timezone.code || 'Asia/Saudi Arabia', code);
                    return slot;
                });
            });
            this.registration_form.timezone.code = code;
            this.registration_form.timezone.label = label;
        },
        convertTimeZone(date, oldTimeZone, newTimeZone) {
            const time = momentTZ.tz(date, oldTimeZone);
            const oldTime = time.format('L');
            time.tz('Asia/Saudi Arabia');
            const londonTime = time.format('L');
            time.tz(newTimeZone);
            const newTime = time.format('L');
            const diff = moment(newTime).diff(moment(londonTime), 'days');
            let res = time.format("HH:mm");
            if(diff) {
                res += '(' + (diff > 0 ? '+' : '') + diff + ')';
            }
            return res;
        }
    },
    created(){
        if (!localStorage.getItem('registeration.client') && !localStorage.getItem('client')) {
            alert('Your session expired .... Please identify your self');
            this.$store.dispatch("endRegisrationProccess")
                .then(() => this.$router.push({name: 'Identify'}));
        }
        else {
            let conference = JSON.parse(localStorage.getItem('conference'));
            let lists = JSON.parse(localStorage.getItem('registeration.lists'));
            if ((_.isEmpty(conference) && !!localStorage.getItem('client')) || _.isEmpty(lists)) {
                return this.fetchDataForUpdate()
                    // .then( () => this.startInit() );
            }
            this.startInit()

        }

        const lateRegisterAvailableSLots = localStorage.getItem('lateRegisterAvailableSLots')
        let late;
        if(lateRegisterAvailableSLots && lateRegisterAvailableSLots != 'undefined') {
            late = JSON.parse(lateRegisterAvailableSLots);
        }

        Object.keys(this.lists.agenda_slots).map((item,index) =>{
            if( late && late[item] )
            {
                this.registration_form.available_slot.push(item);
            }
        });

        this.registration_form.conference_dates = JSON.parse(localStorage.getItem('registeration.conference_dates'));

        if(this.registration_form.available_slot && this.registration_form.available_slot.length)
            {
                if(this.form_options.isPresenter){
                        let keys =  Object.keys(this.lists.agenda_slots);
                        if(keys.length) {
                            const dayNumber = this.registration_form.conference_dates[this.registration_form.available_slot[0]];
                            this.selected_group =
                                Math.ceil(
                                    dayNumber
                                     / this.conference.split_days);
                            console.log('Should be at first');
                            console.log(dayNumber, this.selected_group, this.registration_form.available_slot);
                        }
                }
            }

            if(this.registration_form.timezone.code) {
                Object.keys(this.lists.agenda_slots).forEach(date => {
                    this.lists.agenda_slots[date] = this.lists.agenda_slots[date].map(slot => {
                        slot.start_time = this.convertTimeZone(`${slot.date} ${slot.start_time}`, 'Asia/Saudi Arabia', this.registration_form.timezone.code);
                        return slot;
                    });
                });
            }
    },
    computed: {
        ...mapState(['timeZones']),
        loginDetailsRules() {
            if (this.form_options.enableLoginDetails == true) {
                return {
                    username: {required, minLength:minLength(6)},
                    password : { required, minLength:minLength(6) },
                    password_confirmation : { sameAs: sameAs('password') },
                };
            }
            return {};

        },
        clientDetailsRules() {
            const rules = {
                job_title: {required},
                address: {required},
                country_id: {required},
               /* email: {required, email},
                email_confirmation: {sameAs: sameAs('email')},*/
                additional_email: {email},
                telephone: {required},
                mobile: {required},
                assistant_name: '',
                assistant_phone: {},
                assistant_email: {email},
            }
            if(this.form_options.isInvestor) {
                rules['biography'] = {required};
                // rules['nationality_id'] = {required};
            }

            return rules;
        },
        arrivalDepatureRules(){
            var depature_rules = {};
            var arrival_rules = {};
            if (!this.form_options.disable_arrival_dates && this.form_options.isPresenter == true) {
                 arrival_rules = {
                    arrival_date: {required, minValue: this.validateArrivalDate},
                    arrival_time: {required},
                }
            }else {
                 arrival_rules = {
                     arrival_date:{},
                     arrival_time:{}
                 };
            }

            if (!this.form_options.disable_depature_dates && this.form_options.isPresenter == true) {
                 depature_rules = {
                    departure_date: {required, minValue: this.validateDepatureRule},
                    departure_time: {required},
            }
            }else {
                 depature_rules = {
                     departure_date:{},
                     departure_time:{}
                 };
            }

            return {
                ...arrival_rules,
                ...depature_rules
            }

        },
        groupedSlots(){
            let groups = [
                {groupTitle: 'Available on 14 & 15 June', slots: {},visible:true},
                {groupTitle: 'Available on 16 & 17 June', slots: {},visible:true},
                // {groupTitle: 'Available on 8 & 9 March', slots: {},visible:true}

            ];
            let nextGroup = groups[0];
            let index = 0;
            let group = 0;
            const closed_days = _.map(this.lists.closed_days, val=>val);
            _.each(this.lists.agenda_slots, (timeslots, date) => {
                index ++;


                    if(!(_.includes(closed_days, date) &&
                    !_.includes(this.registration_form.available_slot, ev=>ev == date))){
                        nextGroup.slots[date] = {
                            timeslots,
                            formattedDate: moment(date).format('DD-MM-YYYY')
                        };
                    }
                if(index % 2 == 0) {
                    group ++;
                    nextGroup.groupNumber = group;
                    nextGroup = groups[group];

                }
            });
            console.log(groups);
            groups  = _.filter(groups, g=>_.keys(g.slots).length);
            return groups;

        },
        evenSlots() {
            let index = 0;
            return _.pickBy(this.lists.agenda_slots, (timeslots, date) => {
                index ++;
                if(index % 2 == 0) {
                    return true;
                }
            })
        },
        oddSlots() {
            let index = 0;
            return _.pickBy(this.lists.agenda_slots, (timeslots, date) => {
                index ++;
                if(index % 2 != 0) {
                    return true;
                }
            })
        }

    }
};
</script>

<style type="text/css">
    .dates_investor input[type=checkbox]{
        margin: 0 0px 0 14px !important;
    }
    .alert-danger {
        margin-top:10px;
    }
    .list-group {
        margin:5px;
    }
    .list-group li {
        margin: 5px;
        list-style-type: disc;
    }
    /* .timepicker-input input {

    } */
</style>
